(() => {
  const tiers = [{min:150000,rate:5},{min:300000,rate:7},{min:500000,rate:10}];
  const text = JSON.parse(document.getElementById('kc-discount-text')?.textContent || '{}');
  const fill = (key, values = {}) => Object.entries(values).reduce((result,[name,value]) => result.replaceAll('__'+name+'__',value), text[key] || '');
  document.addEventListener('alpine:init', () => {
    Alpine.data('kcDiscountProgress', () => ({
      get subtotal() {
        return this.$store.cart.cartItems.filter(item => !item.gift_card).reduce((sum,item) => sum + Math.max(0,Number(item.final_line_price ?? Number(item.final_price || 0) * Number(item.quantity || 0))),0);
      },
      get current() { return [...tiers].reverse().find(tier => this.subtotal >= tier.min); },
      get next() { return tiers.find(tier => this.subtotal < tier.min); },
      get progress() { return Math.min(100,this.subtotal / 5000); },
      get applied() { return this.$store.cart.discounts.filter(discount => (/^(?:Sepet avantajı · )?%(?:5|7|10)$/.test(discount.title) || discount.title === "Sepet indirimi")).reduce((sum,discount) => sum + discount.total_allocated_amount,0); },
      get message() {
        if (this.$store.cart.needsCartRefresh) return fill('refresh');
        if (this.$store.cart.isLoading) return fill('updating');
        return this.next ? fill('remaining',{rate:this.next.rate,amount:this.$store.main.getPrice(this.next.min-this.subtotal)}) : fill('maximum');
      },
      get savingMessage() {
        if (!this.current || this.$store.cart.checkoutBlocked) return '';
        return this.applied > 0 ? fill('applied',{amount:this.$store.main.getPrice(this.applied)}) : fill('eligible',{rate:this.current.rate});
      }
    }));
  });
  let trigger = null, previousOverflow = '';
  const dialog = document.getElementById('kc-discount-dialog');
  if (!dialog) return;
  const body = dialog.querySelector('.kc-discount-dialog__body');
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-kc-discount-open]');
    if (!link || !dialog.showModal) return;
    event.preventDefault();
    if (dialog.open) return;
    trigger = link;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    body.scrollTop = 0;
  });
  dialog.querySelector('[data-kc-discount-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (trigger?.isConnected) trigger.focus({preventScroll:true});
  });
  for (const eventName of ['touchmove','wheel']) body.addEventListener(eventName,event=>event.stopPropagation(),{passive:true});
  dialog.addEventListener('keydown', event => { if (['Escape','ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' '].includes(event.key)) event.stopPropagation(); });
})();
